module.exports = __webpack_public_path__ + "static/media/cash-for-used-car-coopers.9657e5a1.png";